import { useQuery } from "react-query";
import { Link, useSearchParams } from "react-router-dom";
import { useDebounce } from "../../../../../_metronic/helpers";
import { PageHeader } from "../../../../components/common/pageHeader/PageHeader";
import { Pagination } from "../../../../components/common/pagination/Pagination";
import { EmptySection } from "../../../../components/sections/empty/Empty";
import { LoaderSection } from "../../../../components/sections/loader/Loader";
import { getVoteRequests } from "../../../../services/voteQuestionSvc";

export const VoteReqPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const searchQuery = searchParams.get("search") || "";

  const debouncedSearch = useDebounce(searchQuery, 500);

  const { data: voteReqs, isLoading: isVoteReqsLoading } = useQuery(
    ["getVoteRequests", page, debouncedSearch],
    () => getVoteRequests({ params: { page, search: debouncedSearch } })
  );

  const pageDetails = {
    title: "Tushgan murojaatlar",
    desc: `Jami murojaatlar: ${voteReqs?.data.length} ta`,
  };

  const totalItems = voteReqs?.total_items || 0;
  const itemsPerPage = voteReqs?.page_size || 8;

  return (
    <div>
      <PageHeader pageDetails={pageDetails} />

      {isVoteReqsLoading ? (
        <LoaderSection height={"50vh"} />
      ) : voteReqs && voteReqs?.data.length > 0 ? (
        <div>
          <div className="card mb-10 table-responsive">
            <table className="table table-striped mx-5 table-hover">
              <thead>
                <tr className="fw-bold">
                  <th scope="col">ID</th>
                  <th scope="col">Ism, Familiya</th>
                  <th scope="col">Murojaat turi</th>
                  <th scope="col">Vaqti</th>
                  <th>Amallar</th>
                </tr>
              </thead>
              <tbody>
                {voteReqs?.data.map((req) => (
                  <tr className="table-row" key={req.id}>
                    <td>{req.id}</td>
                    <td>
                      {req.user.first_name} {req.user.last_name}
                    </td>
                    <td>{req.category.title}</td>
                    <td>{req.created_at}</td>
                    <td>
                      <Link
                        to={`/vote-category/vote-request/${req.id}`}
                        className="btn btn-success btn-sm"
                      >
                        Ko'rish
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination totalItems={totalItems} itemsPerPage={itemsPerPage} />
        </div>
      ) : (
        <EmptySection height={"50vh"} />
      )}
    </div>
  );
};
